


































import Vue from 'vue';
import { ToolsModel } from '@/types';
import { ToolsService } from '@/services/ToolsService';
import MStoreDashboardButton from '@/components/shared/MStoreDashboardButton.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'ToolsDashboard',
  data() {
    return {
      toolsModel: {} as ToolsModel,
      isLoading: false
    };
  },
  async mounted(this: any) {
    this.isLoading = true;
    this.toolsModel = await ToolsService.getToolsAsync();
    this.isLoading = false;
  },
  components: {
    MStoreDashboardButton,
    LoadingSpinner
  }
});
